import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import ProductsReportsListComponent from "./views/ProductsReportsList";

const ProductsReportList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <ProductsReportsListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Product Performance Report",
          description: "Product performance report section"
        })}
      />
      <Routes>
        <Route path={""} element={<ProductsReportList />} />
      </Routes>
    </>
  );
};

export default Component;
